export default __webpack_public_path__ + "static/media/briefcase.131592e4.svg";